import type { BookingSpan } from './calendarHelpers';

export interface CalendarReassignmentDragData {
  bookingId: string;
  sourcePropertyId: string;
  span: BookingSpan;
}

export interface CalendarReassignmentDropData {
  targetPropertyId: string;
}

export interface CalendarReassignmentRequest extends CalendarReassignmentDragData {
  targetPropertyId: string;
}

export function reassignmentRequestFromDrag(
  active: CalendarReassignmentDragData,
  over: CalendarReassignmentDropData | null,
): CalendarReassignmentRequest | null {
  if (!over || active.sourcePropertyId === over.targetPropertyId) return null;
  return { ...active, targetPropertyId: over.targetPropertyId };
}
